/*
 * @Author: Yolo
 * @Date: 2024-06-24 14:15:32
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-06-24 15:47:48
 * @Desc 海盗事件
 */

import L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { AreaViewBase, type AreaViewBaseOptions } from '../AreaViewBase'
import { result } from './PirateSymbolData'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

class PirateSymbol extends AreaViewBase {
  hashMark: Record<number, L.Marker> = {}
  //mark数据缓存
  hash: any[] = []
  hashArea: any[] = []
  markLayer = {}
  markOpt = null

  drawObjs: Record<string, L.Marker> = {}
  checkIDs = []
  locationCenterObj!: L.Layer // 保存选中的图层信息
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, { minzoom: 2, maxzoom: 18, ...options })
    this._data = result.data

    //加载航标点击事件
    map.on('zoomend', () => {
      this.zoomShowMarkToolTip()
    })
  }

  _show(): this {
    if (!this._data) {
      return this
    }
    this.getList()
    this.drawMark()
    return this
  }

  _hide() {
    this.drawMarkClear()
  }

  private getList() {
    this.hash = result.data || []
    this.hashArea = result.area || []
    // this.listHtml()
    this.drawMark()
    this.zoomShowMarkToolTip()
  }

  //绘制标签
  drawMark() {
    const d = this.hash
    if (d == null) {
      return
    }
    this.drawMarkClear()

    for (const [i, element] of d.entries()) {
      if (element.IsShow == 1) {
        const sig = L.icon({
          iconUrl: `https://cdn.xplusship.com/img/images/${this.getPirateImg(
            element.EventTypeCn
          )}.png`,

          iconSize: [20, 28], // size of the icon
          shadowSize: [0, 0], // size of the shadow
          iconAnchor: [10, 28], // point of the icon which will correspond to marker's location
          shadowAnchor: [0, 0], // the same for the shadow
          popupAnchor: [0, -28],
        })
        const newP = CanvasShipUtils.GPSEncryptByMapToLatLng(
          L.latLng(element.Lat, element.Lng),
          this._map
        )
        const latlngMarker: any = [newP.lat, newP.lng]
        const m = L.marker(latlngMarker, {
          icon: sig,
        })

        // m.on('click', function () {})
        this.bounds.push(latlngMarker)
        this.drawObjs[String(element.ID)] = m
        m.bindTooltip(
          `<div class='_pirate_poptip' ><p style='font-weight:bold;text-align:center;font-size:16px;'>${element.EventTypeCn} (${element.EventTypeEn})` +
            `</p><p style='width:160px'>时间：${CommUtils.dataFormat(
              element.EventTime
            )} (UTC)</p><p>坐标：${CanvasShipUtils.latFormatter(
              element.Lat
            )}，${CanvasShipUtils.latFormatter(element.Lng)}</p><p>类型：${
              element.ShipTypeCn
            }</p><p>位置：${element.AddressCn}</p></div>`,
          {
            direction: 'right',
            permanent: false,
            className: 'my_class_pirate',
          }
        )
        m.addTo(this._map)
        this.hashMark[i] = m
      }
    }
    if (this.options.isInit) {
      this._map.fitBounds(this.bounds)
      this.options.isInit = false
    }
  }

  //清楚绘制的标签
  drawMarkClear() {
    this.bounds = []
    const objIDS = Object.keys(this.drawObjs)
    for (const objID of objIDS) {
      const _layer = this.drawObjs[objID]
      if (_layer) {
        this._map.removeLayer(_layer)
      }
    }
  }

  //获取海盗事件图片
  getPirateImg(type: any) {
    let _t = 'qita'
    switch (type) {
      case '可疑船只':
        _t = 'keyichuanzhi'
        break
      case '企图攻击':
        _t = 'qitugongji'
        break
      case '登船':
        _t = 'dengchuan'
        break
      case '交火':
        _t = 'jiaohuo'
        break
      case '劫持':
        _t = 'jiechi'
        break
      case '被盗':
        _t = 'beidao'
        break
      default:
        _t = 'qita'
        break
    }
    return _t
  }

  private zoomShowMarkToolTip() {
    const _zoom = this._map.getZoom()
    const vals = Object.keys(this.hashMark)
    for (const val of vals) {
      if (_zoom >= 6) {
        this.hashMark[Number(val)].openTooltip()
      } else {
        this.hashMark[Number(val)].closeTooltip()
      }
    }
  }
  /**
   * 通过id过去某一个mark的属性
   * @param markId
   */
  openMarkPophtmlByMarkID(markId: string) {
    const ob = this.drawObjs[markId]
    ob.openPopup()
    const { lat, lng } = CanvasShipUtils.GPSEncryptByMapToLatLng(
      L.latLng(ob.getLatLng().lat, ob.getLatLng().lng),
      this._map
    )
    this._map.setView([lat, lng], this._map.getZoom())
    this.locationClose()
    this.locationPic(lat, lng)
  }

  /**
   * 移除图片
   */
  locationClose() {
    this.locationCenterObj && this._map.removeLayer(this.locationCenterObj)
  }

  /**
   * 定位图片显示
   * @param lat
   * @param lon
   */
  locationPic(lat: number, lon: number) {
    const latlon = CanvasShipUtils.GPSEncryptByMapToLatLng(
      L.latLng([lat, lon]),
      this._map
    )
    this._map.setView(latlon, this._map.getZoom())

    const m = L.marker(latlon, {
      icon: L.icon({
        iconUrl: 'https://cdn.xplusship.com/img/images/haidao_chose.png',
        iconSize: [30, 30], // size of the icon
        shadowSize: [0, 0], // size of the shadow
        iconAnchor: [15, 30], // point of the icon which will correspond to marker's location
        shadowAnchor: [0, 0], // the same for the shadow
        popupAnchor: [0, -30],
      }),
    })

    this.locationCenterObj = m
    m.addTo(this._map)
  }
}

const pirateSymbol = (map: MyMap, options?: Partial<AreaViewBaseOptions>) => {
  map.pirateService =
    map.pirateService || new PirateSymbol(map, { ...options, isInit: true })
  return map.pirateService
}
export { pirateSymbol, PirateSymbol }
